<template>
<div class="mCourseList">
    <pull :pull="pull" :page="page" @getList="getList">
        <NoData v-if="!item.courselist.length"></NoData>
        <div class="courseList m-list" v-else>
            <div class="course box" v-for="(obj) in item.courselist" :key="obj.courseid" @click="gotoCourse(obj)">
                <img class="coverurl" :src="obj.coverurl" alt="">
                <div class="subject">{{obj.subject}}</div>
                <div class="price">
                    <span class="tc-blue" v-if="obj.feettype == 1">免费</span>
                    <div v-else class="price-box">
                        <span class="saleprice tc-red">￥{{obj.saleprice}}</span>
                        <!--<span class="uprice tc-grey" v-if="obj.uprice && !obj.islimitcount">￥{{obj.uprice}}</span>-->
                        <span class="limit-label" v-if="obj.islimitcount">限时折扣</span>
                    </div>
                </div>
            </div>
        </div>
    </Pull>
</div>
</template>

<script>
import Pull from 'views/mobile/components/pull/pull'
import {getAllCourseByHost} from 'api/api'
import {mapActions, mapGetters} from 'vuex'
import NoData from 'views/mobile/components/noData/noData'
export default {
    name: 'mCourseList',
    data() {
        return {
            param: {
                hostid: this.$route.query.hostid ? this.$route.query.hostid : '',
                teacherid: this.$route.query.teacherid ? this.$route.query.teacherid : ''
            },
            page: {
                page: 1,
                pagesize: 10,
                pageCount: 2,
                rowCount: 0
            },
            pull: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            },
        }
    },
    props: ['item'],
    mounted() {
    },
    activated() {
        if (this.refresh) {
            this.param.hostid = this.$route.query.hostid ? this.$route.query.hostid : ''
            this.param.teacherid = this.$route.query.teacherid ? this.$route.query.teacherid : ''
        }
    },
    methods: {
        gotoCourse(obj) {
            this.$router.push({name: 'MCourseView', query: {cid: obj.courseid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
            this.setRefresh(true)
        },
        getList() {
            this.setLoading(true)
            getAllCourseByHost({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    if (this.page.page === 1) {
                        this.pull.isLoading = false
                        this.item.courselist = data.data.courselist
                    } else {
                        this.item.courselist = this.item.courselist.concat(data.data.courselist)
                    }
                    this.setLoading(false)
                    this.pull.loading = false
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.page.rowCount = data.data.pageinfo.rowCount
                    if (this.page.page === this.page.pageCount) {
                        this.pull.finished = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.pull.error = true
                    this.pull.loading = false
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['refresh'])
    },
    components: {
        Pull, NoData
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.mCourseList {
    .courseList{
        background: $c-white;
    }
}
</style>